import React, { Component } from "react";
import "react-quill/dist/quill.snow.css";
import Select from "react-select";
import Quill from "react-quill";
import { list } from "../../../services/industry";
import AppContext from "../../../contexts/AppContext";

class UpdateModel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: {},            
            errors: {}, 
            user_industries: [],
            uid: [],
            industries: [],  
            selectedFile : '',
            bylined: false,
            showBylineDiv : false          
            
        };
    }

    modules = {
        toolbar: [         
          ['bold', 'italic', 'underline'],
		  ['link'],
          ['clean'],
		],
    }

    fileChangedHandler = (event) => {
        const file = event.target.files[0];
        this.setState({ selectedFile: file });
    }

    handleCheck = () => {
        this.setState({ showBylineDiv: this.state.showBylineDiv === true ? false : true });
    }

    handleCheckPaid = () => {
        let temp = this.state.item;
        temp["paid"] = this.state.item.paid === true ? false : true;
        this.setState({ item: temp });
    }

    handleQuillChange = value => {
        let temp = this.state.item;
        temp.submission_note = value;

        let error = this.state.errors;
        error.submission_note = null;

        this.setState({ item: temp, errors: error });
    };


    handleChange = field => {
        let temp = this.state.item;
        let error = this.state.errors;
        temp[field.target.id] = field.target.value; 
        error[field.target.id] = null;   
        this.setState({ item: temp, errors: error });
        //this.setState({ [e.target.id]: e.target.value });
    };

    componentDidMount() {
        list()
            .then(res => {
                this.setState({ industries: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
        this.setState({ 
            item: this.props.meta ,  
            user_industries: this.props.item.user_industries,          
            bylined: this.props.meta.accept_byline_submission,
            showBylineDiv : this.props.meta.accept_byline_submission, 
        });
    }

    stripHtmlToText(html)
    {
        var tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        var res = tmp.textContent || tmp.innerText || '';
        res.replace('\u200B', ''); // zero width space
        res = res.trim();
        return res;
    }

    handleValidation(){
        let fields = this.state.item;
        let errors = {};
        let formIsValid = true;  
        let sn = this.stripHtmlToText(fields.submission_note);

        if(this.state.showBylineDiv && !fields.submission_url){
            formIsValid = false;
            errors.submission_url = "Please enter submission url.";
        }   

        if(this.state.showBylineDiv && fields.submission_url && !(fields.submission_url).match(/\(?(?:(http|https|ftp):\/\/)?(?:((?:[^\W\s]|\.|-|[:]{1})+)@{1})?((?:www.)?(?:[^\W\s]|\.|-)+[\.][^\W\s]{2,4}|localhost(?=\/)|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?::(\d*))?([\/]?[^\s\?]*[\/]{1})*(?:\/?([^\s\n\?\[\]\{\}\#]*(?:(?=\.)){1}|[^\s\n\?\[\]\{\}\.\#]*)?([\.]{1}[^\s\?\#]*)?)?(?:\?{1}([^\s\n\#\[\]]*))?([\#][^\s\n]*)?\)?/g))
        {
            formIsValid = false;
            errors.submission_url = "Please enter valid submission url.";
        }

        if(this.state.showBylineDiv && fields.submission_note && sn.length > 200)
        {
            formIsValid = false;
            errors.submission_note = "Please limit submission note by 200 charecters.";
        }

        this.setState({errors: errors});
        return formIsValid;
    }

    update = e => {
        e.preventDefault();
        const formData = new FormData();
        if(this.handleValidation()){
            formData.append(
                'location_of_HQ',
                this.state.item.location_of_HQ,
            );
            formData.append(
                'company_info',
                this.state.item.company_info,
            );
            formData.append(
                'company_address',
                this.state.item.company_address,
            );
            formData.append(
                'company_size',
                this.state.item.company_size,
            );
            formData.append(
                'company_website',
                this.state.item.company_website,
            );
            formData.append(
                'name',
                this.state.item.name,
            );
            formData.append(
                'year_founded',
                this.state.item.year_founded,
            );
            formData.append(
                'state',
                this.state.item.state,
            );
            if(this.state.selectedFile)
            {
                formData.append(
                    'file',
                    this.state.selectedFile,
                    this.state.selectedFile.name
                )
            }
            formData.append(
                'accept_byline_submission',
                this.state.showBylineDiv,
            );
    
            formData.append(
                'submission_url',
                this.state.item.submission_url,
            );
    
            formData.append(
                'paid',
                this.state.item.paid,
            );
            formData.append(
                'payout_start',
                this.state.item.payout_start,
            );
    
            formData.append(
                'payout_end',
                this.state.item.payout_end,
            );
    
            formData.append(
                'submission_note',
                this.state.item.submission_note,
            );
    
            formData.append(
                'user_id',
                this.props.item.id,
            );
    
            formData.append(
                'user_type',
                'internal'
            );
            formData.append(
                'user_industries',
                this.state.uid,
            );
            //console.log(this.state.user_industries);
            this.props
                .update(this.props.item.id, formData)
                .then(response => {
                    this.props.hideUpdate();
                    this.context.state.showCodeMessage(
                        `Record has been updated!`,
                        "success"
                    );
                })
                .catch(errors => {
                    switch (errors.response.status) {
                        case 422:
                            this.setState({ errors: errors.response.data.error });
                            break;
                        default:
                            this.context.state.handelError(errors);
                            break;
                    }
                });
        }
        
    };

    onChange(field) {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;

        let error = this.state.errors;
        error[field.target.name] = null;

        this.setState({ item: temp, errors: error });
    }
    handleSelectChange = selectedOption => {
        let temp = this.state;
        temp["uid"] = [];
        temp["user_industries"] = [];

        if (selectedOption !== null) {
            for (let index = 0; index < selectedOption.length; index++) {
                temp["uid"][index] = selectedOption[index].value;
                temp["user_industries"].push({
                    industry_id: selectedOption[index].value
                });
            }
        }
        let error = this.state.errors;
        error.industries = null;
        //console.log(temp);
        this.setState({ uid: temp['uid'], user_industries: temp['user_industries'], errors: error });
    };
    render() {

        const optionsList = [];
        for (let index = new Date().getFullYear(); index >= 1990; index--) {
            optionsList.push(<option value={index}>{index}</option>);
        }
        return (
            <div className="model-container model-center model-backdrop-show">
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popuplg model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <h2 className="mb-5">Update record</h2>
                    <div className="model-content">
                        <form onSubmit={this.update} className="BylineForm">
                            <div className="row">
							    <div className="col-sm-6">
							        <div className="form-group">
                                        <label htmlFor="name">
                                            Company name
                                        </label>
                                        <input
                                            id="name"
                                            value={this.state.item.name} 
                                            onChange={this.handleChange}                                              
                                            type="text"
                                            className="form-control"
                                        />
                                    </div>
                                </div>
								<div className="col-sm-6">
                                    <div className="form-group">
                                        <label htmlFor="location_of_HQ">
                                            Location of headquarters
                                        </label>
                                        <input
                                            id="location_of_HQ"
                                            onChange={
                                                this.handleChange
                                            }
							        
                                            value={
                                                this.state.item.location_of_HQ
                                            }
                                            type="text"
                                            className="form-control"
                                        />
                                    </div>
								</div>
								<div className="col-sm-6">	
                                    <div className="form-group">
                                        <label htmlFor="company_website">
                                            Company Website
                                        </label>
                                        <input
                                            id="company_website"
                                            onChange={
                                                this.handleChange
                                            }
                                            value={
                                                this.state.item.company_website
                                            }
                                           
                                            type="url"
                                            className="form-control"
                                        />
                                    </div>
								</div>
								<div className="col-sm-6">	
                                    <div className="form-group">
                                        <label htmlFor="year_founded">
                                            Year founded
                                        </label>
                                        <select
                                            id="year_founded"
                                            maxLength="4"
                                            onChange={
                                                this.handleChange
                                            }
                                            value={
                                                this.state
                                                    .item.year_founded
                                            }
                                            
                                            type="text"
                                            className="form-control"
                                        >
                                            {optionsList}
                                        </select>
                                    </div>
								</div>
								<div className="col-sm-6">	
                                    <div className="form-group">
                                        <label htmlFor="company_address">
                                            Company Address
                                        </label>
                                        <input
                                            id="company_address"
                                            onChange={this.handleChange}                                    
                                            type="text"
                                            value={
                                                this.state
                                                    .item.company_address
                                            }
                                            className="form-control"
                                            placeholder="Enter your company address"
                                            autoComplete="off"
                                        />
                                    </div>
								</div>
								<div className="col-sm-6">	
                                    <div className="form-group">
                                        <label htmlFor="company_size">
                                            Company Size
                                        </label>
                                        <select
                                            className="form-control m-input"
                                            data-toggle="select"
                                            id="company_size"                                    
                                            value={this.state.item.company_size}
                                            onChange={this.handleChange}
                                        >
                                            <option value="1 - 3">
                                                1 - 3
                                            </option>
                                            <option value="4 - 10">
                                                4 - 10
                                            </option>
                                            <option value="10 - 100">
                                                10 - 100
                                            </option>
                                            <option value="100+">
                                                100+
                                            </option>
                                        </select>
                                    </div>
								</div>
								<div className="col-12">	
                                    <div className="form-group">
                                        <label htmlFor="company_info">
                                            Company Overview
                                        </label>
                                        <textarea
                                            placeholder="what you do, why you do it, who you do it for..."
                                            style={{
                                                minHeight: "100px"
                                            }}                                   
                                            value={
                                                this.state
                                                    .item.company_info
                                            }
                                            id="company_info"
                                            onChange={
                                                this.handleChange
                                            }
                                            rows="3"
                                            type="text"
                                            className="form-control"
                                        ></textarea>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="name">Industries <i className="info fe fe-help-circle ml-3" data-toggle="tooltip" data-placement="top" title="Select the industries associated with your website or brand."></i></label>
                                        <div className="industries_container">
                                            
                                            <Select
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        "&:hover": {
                                                            borderColor: "#1cd2ad",
                                                            boxShadow: "none"
                                                        },
                                                        "&": {
                                                            borderColor: "#d2ddec",
                                                            boxShadow: "none"
                                                        }
                                                    }),
                                                    dropdownIndicator: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    }),
                                                    singleValue: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    })
                                                }}
                                                isMulti={true}
                                                name="industries"
                                                className="select2"
                                                value={this.state.industries.filter(
                                                    item => {
                                                        const temp = this.state.user_industries.map(
                                                            item => item.industry_id
                                                        );
                                                        return (
                                                            temp.indexOf(item.id) >= 0
                                                        );
                                                    }
                                                )}
                                                onChange={this.handleSelectChange}
                                                options={this.state.industries}
                                            ></Select>
                                        </div>	
                                        {this.state.errors.industries ? (
                                            <div className="invalid-feedback">
                                                The industries field is required.
                                            </div>
                                        ) : null}
                                    </div>
								</div>
                                
								<div className="col-sm-6">	
                                    <div className="form-group">
                                        <label htmlFor="company_image">Company logo</label>
                                        <input
                                            id="file"
                                            name="file"                                           
                                            onChange={this.fileChangedHandler}
                                            type="file"
                                            className="form-control"
                                            accept="image/*"
                                        />
                                    </div>
								</div>
								<div className="col-sm-6">	
                                    <div className="form-group">
                                        <label htmlFor="name">Status</label>
                                        <select
                                            onChange={this.onChange.bind(this)}
                                            type="text"
                                            className="form-control"
                                            id="state"
                                            value={this.state.item.state}
                                            name="state"
                                        >
                                            <option value="applied">Applied</option>
                                            <option value="approved">Approved</option>
                                            <option value="rejected">Declined</option>
                                        </select>
                                        {this.state.errors.state ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.state}
                                            </div>
                                        ) : null}
                                    </div>
								</div>
								
                                <div className="form-group d-flex align-items-center col-12">
                                    <div className="custom-control custom-switch mr-3">
                                        <input
                                            onChange={
                                                this.handleCheck
                                            }
                                            checked={
                                                this.state.showBylineDiv
                                            }
                                            type="checkbox"
                                            className="custom-control-input"
                                            id="bylined_submissions"
                                        />
                                        <label
                                            className="custom-control-label"
                                            htmlFor="bylined_submissions"
                                        ></label>
                                    </div>
                                    <label className="mb-0">
                                        Accepts Bylined Submissions <span className="ml-2" data-toggle="tooltip" data-placement="top" title="Do you accept and publish bylined article submissions from writers?"><i className="fe fe-help-circle"></i></span>
                                    </label>
                                </div>

                            { this.state.showBylineDiv ? 
                            <div className="col-12">
                                    <div className="form-group">
                                    <label htmlFor="submission_url">
                                        Submissions Details URL
                                    </label>
                                    <input
                                        id="submission_url"  
                                        onChange={this.handleChange}                                   
                                        value={
                                            this.state.item.submission_url
                                        }                                   
                                        type="url"
                                        className="form-control"
                                    />
                                    {this.state.errors.submission_url ? (
                                                <div className="text-danger">
                                                    {this.state.errors.submission_url}
                                                </div>
                                            ) : null}
                                </div>

                                    <div className="form-group ">
                                        <label
                                            className="mb-1"
                                            htmlFor="description"
                                        >
                                            Submission Notes
                                        </label>
                                       
                                        <Quill
                                            modules={this.modules}
                                            onChange={this.handleQuillChange}
                                            value={
                                                this.state.item.submission_note
                                            }
                                        ></Quill>

                                        {this.state.errors.submission_note ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.submission_note}
                                            </div>
                                        ) : null}
                                    </div>
                            
                                    <div className="form-group">
                                        <label htmlFor="name">
                                            
                                        </label>
                                        <input
                                            checked={this.state.item.paid}  
                                            onChange={this.handleCheckPaid}                                 
                                            className="react-switch-checkbox"                                            
                                            type="checkbox"
                                        /> Paid
                                    </div> 
                                    {this.state.item.paid ? 
                                    
                                    <div className="form-group">
                                        <label htmlFor="name">
                                            Payout
                                        </label>
										<div className="d-flex align-items-center justify-content-between">
                                            <input
                                                id="payout_start"  
                                                name="payout_start"
                                                onChange={this.handleChange} 
                                                value={this.state.item.payout_start} 
                                                className="form-control input-sm"                                         
                                                type="number"
                                            /> 
										    <span className="ml-3 mr-3">-</span>
                                            <input
                                                id="payout_end"  
                                                name="payout_end"
                                                onChange={this.handleChange} 
                                                value={this.state.item.payout_end} 
                                                className="form-control input-sm"                                         
                                                type="number"
                                            />
										</div>
                                    </div> 
                                    
                                    : ''}       
                            </div>
                            : '' }
                                
                                <div className="col-12">	
                                    <button
                                        type="button"
                                        onClick={this.update}
                                        className="btn btn-primary mr-2"
                                    >
                                        Submit
                                    </button>
                                    <button
                                        type="button"
                                        onClick={this.props.hideUpdate}
                                        className="btn btn-default"
                                    >
                                        Cancel
                                    </button>
								</div>
							</div>	
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
UpdateModel.contextType = AppContext;
export default UpdateModel;



// WEBPACK FOOTER //
// ./src/components/admin/employers/UpdateModel.js